import type { AmbleContent } from "../..";
import { getAffordableQuotesConsumerAccuracy } from "../../shared/get-affordable-quotes";
import { getPartnerDisclaimerTermsOfPolicy } from "../../shared/terms-of-policy";

export const ambles: Record<string, AmbleContent> = {
  usa_business_get_affordable_quotes: getAffordableQuotesConsumerAccuracy,
  terms_of_policy: getPartnerDisclaimerTermsOfPolicy("Luxy Beauty Courses"),
};
